export type StoreImagePurpose = 'store-cover' | 'store-logo';

export function buildStoreImagePatch(purpose: StoreImagePurpose, url: string): { coverUrl: string } | { logoUrl: string } {
  return purpose === 'store-cover' ? { coverUrl: url } : { logoUrl: url };
}
